<div class="flex items-center justify-between mb-3">
  <p class="text-xs text-gray-500">{{ titulo }}</p>
  <button
    type="button"
    (click)="baixarTodas()"
    [disabled]="isBaixandoTodas || isCarregando"
    class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-white bg-primario-700 rounded-lg hover:bg-blue-800 transition-colors disabled:opacity-50"
  >
    <span class="material-icons" style="font-size: 16px;">download</span>
    {{ 'galeria.btn.baixar.todas' | message }}
  </button>
</div>

<div *ngIf="isCarregando" class="grid grid-cols-4 gap-2">
  <div *ngFor="let _ of [1,2,3,4]" class="aspect-square rounded-lg bg-gray-200 skeleton"></div>
</div>

<div *ngIf="!isCarregando && fotos.length > 0" class="relative">

  <button
    *ngIf="indiceCarrossel > 0"
    type="button"
    (click)="fotoAnteriorCarrossel()"
    class="absolute -left-4 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-primario-700 shadow text-white flex items-center justify-center hover:bg-blue-800 transition-colors"
  >
    <span class="material-icons">chevron_left</span>
  </button>

  <div class="grid grid-cols-4 gap-2">
    <div
      *ngFor="let foto of fotosVisiveis; let i = index"
      class="relative rounded-lg overflow-hidden bg-gray-100 aspect-square"
      [class.cursor-pointer]="!foto.carregando"
      [class.group]="!foto.carregando"
      (click)="abrirLightbox(indiceCarrossel + i)"
    >
      <div *ngIf="foto.carregando" class="w-full h-full bg-gray-200 skeleton"></div>

      <ng-container *ngIf="!foto.carregando">
        <img
          [src]="foto.url"
          class="w-full h-full object-cover transition-all duration-500 ease-in-out group-hover:scale-105"
          style="animation: fadeIn 0.4s ease-in-out;"
          [attr.alt]="'galeria.foto.alt' | message"
        />

        <div class="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors"></div>

        <div class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          <span class="material-icons text-white drop-shadow" style="font-size: 28px;">zoom_in</span>
        </div>

        <button
          type="button"
          (click)="baixarFoto(foto); $event.stopPropagation()"
          class="absolute top-1.5 right-1.5 z-10 w-7 h-7 rounded-lg bg-black/50 text-white flex items-center justify-center hover:bg-black/70 transition-colors"
          [title]="'galeria.btn.baixar.foto' | message"
        >
          <span class="material-icons" style="font-size: 16px;">download</span>
        </button>
      </ng-container>
    </div>
  </div>

  <button
    *ngIf="indiceCarrossel + 4 < fotos.length"
    type="button"
    (click)="proximaFotoCarrossel()"
    class="absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-primario-700 shadow text-white flex items-center justify-center hover:bg-blue-800 transition-colors"
  >
    <span class="material-icons">chevron_right</span>
  </button>

</div>

<div *ngIf="!isCarregando && fotos.length === 0" class="flex items-center justify-center h-28 rounded-xl bg-gray-50 border border-dashed border-gray-200">
  <p class="text-xs text-gray-400">{{ 'galeria.sem.registro' | message }}</p>
</div>

<div
  *ngIf="lightboxAberto"
  class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/90"
  (click)="fecharLightbox()"
>
  <div class="flex items-center justify-center w-full h-full" (click)="$event.stopPropagation()">

    <div
      class="relative inline-flex rounded-lg"
      [class.overflow-hidden]="!zoomAtivo"
      style="max-height: 80vh; max-width: 90vw;"
    >
      <img
        [src]="fotosCarregadas[indiceLightbox].url"
        class="block object-contain rounded-lg transition-transform duration-300 ease-in-out"
        [style.transform]="zoomAtivo ? 'scale(2.5)' : 'scale(1)'"
        [style.transform-origin]="zoomOrigin"
        [style.cursor]="zoomAtivo ? 'zoom-out' : 'zoom-in'"
        style="max-height: 80vh; max-width: 90vw; width: auto; height: auto;"
        (click)="toggleZoom($event)"
        [attr.alt]="'galeria.foto.alt' | message"
      />

      <ng-container *ngIf="!zoomAtivo">

        <span class="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-black/50 text-white text-xs">
          {{ indiceLightbox + 1 }} / {{ fotosCarregadas.length }}
        </span>

        <div class="absolute top-3 right-3 flex items-center gap-1.5">
          <button
            type="button"
            (click)="baixarFoto(fotosCarregadas[indiceLightbox])"
            class="w-8 h-8 flex items-center justify-center rounded-lg bg-black/50 text-white hover:bg-black/70 transition-colors"
            [title]="'galeria.btn.baixar.foto' | message"
          >
            <span class="material-icons text-base">download</span>
          </button>
          <button
            type="button"
            (click)="fecharLightbox()"
            class="w-8 h-8 flex items-center justify-center rounded-lg bg-black/50 text-white hover:bg-black/70 transition-colors"
          >
            <span class="material-icons text-base">close</span>
          </button>
        </div>

        <button
          *ngIf="fotosCarregadas.length > 1"
          type="button"
          (click)="fotoAnteriorLightbox()"
          class="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-black/70 transition-colors"
        >
          <span class="material-icons">chevron_left</span>
        </button>

        <button
          *ngIf="fotosCarregadas.length > 1"
          type="button"
          (click)="proximaFotoLightbox()"
          class="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-black/70 transition-colors"
        >
          <span class="material-icons">chevron_right</span>
        </button>

      </ng-container>

    </div>
  </div>
</div>
